export default "/images/geraldine.jpg?b7c9b7e9a8c46ce15660352e2dd57c43";